import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { guid } from "@methods/uniqueMethods";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";

@Component({
    selector: "cerrix-toggle-info",
    templateUrl: "./cerrix-toggle-info.component.html",
    styleUrls: ["./cerrix-toggle-info.component.scss"],
    imports: [TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CerrixToggleInfoComponent,
            multi: true,
        },
    ],
})
export class CerrixToggleInfoComponent implements OnInit, ControlValueAccessor {
    valid = true;
    _value: boolean;

    _onChangeFormValidation = Function.prototype;
    _onTouchedFormValidation = Function.prototype;

    @Input() id: string;
    @Input() title: string;
    @Input() description: string;
    @Input() toggleInfo: string;

    @Input() disabled = false;
    @Input() ngModelOptions = {};
    @Input() dataUiid: string = guid();

    @Input() descriptionClick: () => void;
    @Input() beforeChange: (currentValue: boolean) => Promise<boolean>;
    @Output() valueChange = new EventEmitter<boolean>();

    @Input() initialValue: boolean;

    @Input()
    set value(value: boolean) {
        if (this._value === value) {
            return;
        }

        this._value = value;
        this.valueChange.emit(value);
        this._onChangeFormValidation(value);
    }
    get value(): boolean {
        return this._value;
    }

    descriptionClicked(): void {
        if (this.descriptionClick) {
            this.descriptionClick();
        }
    }

    toggleSwitch(): void {
        if (this.beforeChange) {
            this.beforeChange(this.value).then((shouldChange: boolean) => {
                if (shouldChange) {
                    this.value = !this.value;
                }
            });
        } else {
            this.value = !this.value;
        }
    }

    constructor() {}

    ngOnInit(): void {
        if (this.initialValue !== undefined) {
            this._value = this.initialValue;
        }
    }

    // Form Validation
    writeValue(obj: any): void {
        this.value = obj;
    }
    registerOnChange(fn: any): void {
        this._onChangeFormValidation = fn;
    }
    registerOnTouched(fn: any): void {
        this._onTouchedFormValidation = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
